import { ChangeDetectionStrategy, Component, Input, SimpleChanges } from '@angular/core';
import * as _ from 'lodash';
import * as Highcharts from 'highcharts';
import { HttpClient } from '@angular/common/http';
import { LineOrTrendedService } from '../../line-or-trended.service';
import { Observable, Subscription } from 'rxjs';
import { SnapshotService } from 'src/app/modules/snapshot/Services/snapshot.service';
import { COMMON_CONSTANTS, COMMON_CONSTANTS_Percentage, COMMON_CONSTANTS_SNAPSHOT } from 'src/app/common/constants/common-constants';

@Component({
  selector: 'app-line-or-trend-chart1',
  template: '<div id="chartContainer"></div>',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Lineortrendchart1Component {
  @Input() trendData: any;
  @Input() height: any;
  @Input() Top10Toggle: any;
  @Input() DataLabelOn: any;
  data: any;
  LineChartData: any[] = [];
  ChartProperties: any;
  categoriesList: any;
  updateCategoryName: any = [];
  colorCodeList: any[] = [];
  seriesData: any[] = [];
  chart: any;
  custom: any[] = [];
  event: any;
  changeValue: any[] = [];
  significanceValue: any;
  sampleSizeValues: any[] = [];
  actualDataValue: any[] = [];
  chartCategories: any;
  samplesizeConstantValue = this._configService.ISthreshold;
  chartMinAxis: any;
  chartMaxAxis: any;
  showLowSample: any;

  Sig_LowerLimt = COMMON_CONSTANTS.SigLowerLimit_95;
  Sig_UpperLimt = COMMON_CONSTANTS.SigUpperLimit_95;
  DefaultConfidenceLevel: any = '';
  private subscriptions: Subscription = new Subscription();
  constructor(
    public http: HttpClient,
    public LineTrendService: LineOrTrendedService,
    private _configService: SnapshotService
  ) { }

  ngOnInit(): void {
    //this.categoriesList = ["Oct'2023", "Nov'2023", "Dec'2023", "Jan'2024", "Feb'2024"]
    this.updatesig();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.updatesig();
  }

  updatesig() {
    this.Sig_LowerLimt =
      this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_95
        ? COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_95
        : this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_90
          ? COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_90
          : this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_98
            ? COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_98
            : COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_95;
    this.Sig_UpperLimt =
      this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_95
        ? COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_95
        : this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_90
          ? COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_90
          : this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_98
            ? COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_98
            : COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_95;

    this.preparemainChartData(this.trendData);
    this.subscriptions.add(
      this._configService.confedenceValue.subscribe((value) => {
        this.DefaultConfidenceLevel = value;
      }));
    this.subscriptions.add(
      this._configService.significanceValue.subscribe((value) => {
        this.significanceValue = value;
      }));
    this.subscriptions.add(
      this.http.get<any>('assets/Data/lineChartData.json').subscribe(
        (jsonData) => {
          this.ChartProperties = jsonData[0].properties[0];
          this.colorCodeList = jsonData[0].ColorCodes;
          this.ChartProperties.datalabelStyle =
            this.significanceValue == 'None' ? 'datalabel' : 'sigChange';
            this.ChartProperties.datalabelStyle = this._configService.isIndexSelected ? "index" : this.ChartProperties.datalabelStyle;
          this.ChartProperties.datalabelStyle = this._configService
            .isIndexSelected
            ? 'index'
            : this.ChartProperties.datalabelStyle;

          this.plotLineChart('chartContainer');
        },
        (error) => {
          console.error('Error fetching data:', error);
        }
      ));
  }

  chartMainData: any = [];
  preparemainChartData(data: any) {
    let i = 0;
    this.chartMainData = [];
    data.forEach((lev1: any) => {
      lev1.metricSelected.metrics.forEach((lev2: any, index: number) => {
        if (
          this.Top10Toggle == false ||
          (this.Top10Toggle == true && index < 10)
        ) {
          lev2.data.forEach((dataArr: any) => {
            let d1 = {
              'Series Name': lev2.metricName,
              'Category Name': dataArr.lvl1Child,
              'Rounded Value':
                dataArr.data == null
                  ? null
                  : dataArr.CalculationType?.toLowerCase() == 'share' ||
                    dataArr.CalculationType?.toLowerCase() == 'respgrp'
                    ? dataArr.data * 100
                    : dataArr.data,
              'Value':
                dataArr.CalculationType?.toLowerCase() == 'share' ||
                  dataArr.CalculationType?.toLowerCase() == 'respgrp'
                  ? dataArr.data * 100
                  : dataArr.data,
              "ValueForIndex": (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
              "ActualIndexValue": (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == null) ? null : (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
              'Label':
                dataArr.data == null
                  ? 'NA'
                  : dataArr.CalculationType?.toLowerCase() == 'share' ||
                    dataArr.CalculationType?.toLowerCase() == 'respgrp'
                    ? dataArr.data * 100
                    : dataArr.data,
              'ChangeVs': dataArr.changeVsPY,
              'Significance': '-1',
              'Sample size': dataArr.baseValueforLSorIs,
              'Significance2': '1',
              'Category Image': 'Category_Image_1',
              'isPercentage':
                dataArr.CalculationType?.toLowerCase() == 'share' ||
                  dataArr.CalculationType?.toLowerCase() == 'respgrp'
                  ? true
                  : false,
              'Sig_LowerLimt': this.Sig_LowerLimt,
              'Sig_UpperLimt': this.Sig_UpperLimt,
              "Significance_Value": dataArr.Significance_Value
            };
            this.chartMainData.push(d1);
          });
        }
      });
    });
    // this.chartMainData=this.chartMainData.slice(0,1);
  }

  customization(): Observable<any[]> {
    return this.LineTrendService.Line1CustomizationList();
  }

  applycustomization(event: any, item: string) {
    this.event = event;
    //choose the appropriate customization
    this.LineTrendService.applycustomization(event, item, this.ChartProperties);
    this.plotLineChart('chartContainer');
  }

  plotyaxis() {
    if (
      this.ChartProperties.stacking == 1 ||
      this.ChartProperties.stacking == 2
    ) {
      return {
        title: {
          text: '',
          style: {
            color: this.ChartProperties.darkTheme ? 'white' : 'Black',
          },
        },

        gridLineWidth: this.ChartProperties.gridlines,
        labels: {
          rotation: this.LineTrendService.axisLabelOrientation(
            this.ChartProperties.yaxisLabelOrientation
          ),
          format:
            this.ChartProperties.datalabelFormat == 'number'
              ? '{value}'
              : '{value}%',
          style: {
            color: this.ChartProperties.darkTheme ? 'white' : 'Black',
          },
        },
      };
    } else {
      return {
        title: {
          text: '',
          style: {
            color: this.ChartProperties.darkTheme ? 'white' : 'Black',
          },
        },
        min: this.showLowSample ? 0 : this.chartMinAxis,
        // max: this.chartMaxAxis > 100 ? 100 : this.chartMaxAxis,
        max: this.chartMaxAxis,
        gridLineWidth: this.ChartProperties.gridlines,
        labels: {
          rotation: this.LineTrendService.axisLabelOrientation(
            this.ChartProperties.yaxisLabelOrientation
          ),
          format:
            this.ChartProperties.datalabelFormat == 'number'
              ? '{value}'
              : '{value}%',
          style: {
            color: this.ChartProperties.darkTheme ? 'white' : 'Black',
          },
        },
      };
    }
  }

  plotLineChart(containerId: any) {
    localStorage.setItem('properties', JSON.stringify(this.ChartProperties));
    this.prepareSeriesDataForChart();
    let properties = this.ChartProperties;
    let samplesizeConstantValue = this._configService.ISthreshold;
    //const updatedCategoryNames = this.LineTrendService.updatedCategories.map(category => category.image);
    //let updatedCategories = this.LineTrendService.updatedCategories;
    let ispercentage = false;
    let that = this;
    let colors = this.colorCodeList;
    if (this.ChartProperties.datalabelFormat === 'percentage') {
      ispercentage = true;
    }

    if (
      this.ChartProperties.stacking == 1 ||
      this.ChartProperties.stacking == 2
    ) {
      this.seriesData.reverse();
    }

    let configService = this._configService;

    this.chart = new Highcharts.Chart(containerId, {
      chart: {
        type: 'line',
        marginLeft: 50, // Increase left margin
        marginRight: 50,
        animation: false,
        height: '50%',
        width: null,
        backgroundColor: this.ChartProperties.darkTheme ? 'Black' : 'white',
        style: {
          color: this.ChartProperties.darkTheme ? 'white' : 'Black',
          fontFamily: 'KantarBrown-Regular',
        },
      },
      title: {
        text: '',
        style: {
          color: this.ChartProperties.darkTheme ? 'white' : 'Black',
        },
        align: this.ChartProperties.chartTitlePosition,
      },
      credits: {
        enabled: false,
      },
      yAxis: this.plotyaxis(),
      xAxis: {
        title: {
          text: '',
          style: {
            fontSize: '12px',
            color: '#E8E8E8',
          },
        },
        // min: 0,
        gridLineWidth: this.ChartProperties.gridlines,
        categories: properties.axisImage
          ? this.updateCategoryName
          : this.categoriesList,
        labels: {
          rotation: this.LineTrendService.axisLabelOrientation(
            this.ChartProperties.axisLabelOrientation
          ),
          style: {
            color: this.ChartProperties.darkTheme ? 'white' : 'Black',
          },
          useHTML: true,
          formatter: function (
            this: Highcharts.AxisLabelsFormatterContextObject
          ) {
            if (properties.axisImage) {
              var index = this.axis.categories.indexOf(String(this.value));
              var category = that.updateCategoryName[index];

              if (category) {
                return (
                  '<span style="display: inline-block; width: 2em; height: 2em; background: url(../../../../../../assets/Images/LineOrTrendChart/' +
                  category +
                  '.png) no-repeat center center; background-size: cover;"></span>'
                );
              } else {
                return '<span>No Image</span>';
              }
            } else {
              return String(this.value);
            }
          },
        },
      },

      tooltip: {
        enabled: true,
        borderWidth: 0,
        useHTML: true,
        shape: properties.toolTipStyle == 'style1' ? 'square' : 'callout',
        shadow: false,
        backgroundColor: 'rgba(0,0,0,0)',

        formatter: function (this: any) {
          const pointWithMetric = (
            this as Highcharts.TooltipFormatterContextObject
          ).point as {
            name?: any;
            parent?: any;
            color?: any;
            y?: number;
            y1?: number;
            cov?: string;
            significance?: string;
            samplesize?: number;
            significance2?: any;
            tooltip?: any;
            isPercentage?: any;
            Sig_LowerLimt?: any;
            Sig_UpperLimt?: any;
            Significance_Value?: any;
            indexValue?:any
          };

          let roundedValue = this.series.userOptions.data1[this.point.x]['Rounded Value'];
          properties.dataLabelFormat = pointWithMetric.isPercentage;
          if (roundedValue == null)
            pointWithMetric.tooltip = 'NA';
          if (properties.datalabelStyle === 'index') {

            let finalText =
              this.y +
              (this.series.userOptions.data1[this.point.x]['isPercentage'] &&
                '%');
            finalText = configService.CheckLSorIScondition(
              configService.userRole,
              finalText,
              this.series.userOptions.data1[this.point.x]['Sample size']
            );
            // pointWithMetric.tooltip = finalText;


            let text2 =
            pointWithMetric.y1 == 0 ? 'NA' :pointWithMetric.y1 != null ? pointWithMetric.indexValue : 'NA';
            //text = configService.CheckLSorIScondition(configService.userRole, text, Number(pointWithMetric.samplesize));
            let color = configService.CheckIndexColoring(String(text2));
            text2 = `<span style="color: ${color} ;">${text2}</span>`;
            pointWithMetric.tooltip =finalText+ "("+text2+")";
            // return (
            //   '<span style="color:' + 'black' + ';">' + text + '</span>'
            // );
          }
          else if (properties.datalabelStyle === 'sigChange') {
            let changeVal = pointWithMetric.isPercentage
              ? Number(pointWithMetric.cov) * 100
              : Number(pointWithMetric.cov);
            if (
              pointWithMetric.cov == null ||
              pointWithMetric.cov == 'NA'
            ) {
              let text =
                pointWithMetric.y1 != null
                  ? pointWithMetric.y +
                  (properties.dataLabelFormat ? '%' : '') +
                  ' ' +
                  `<span span style="font-size: 80%;color:black;">(${'NA'})</span>`
                  : 'NA';
              pointWithMetric.tooltip = text;
              // return (
              //   '<span style:"color:' + 'black' + ';">' + text + '</span>'
              // );
            } else {
              let val = pointWithMetric.y != null
                ? pointWithMetric.y +
                (properties.dataLabelFormat ? '%' : '') : 'NA';
              val = configService.CheckLSorIScondition(
                configService.userRole,
                val,
                pointWithMetric.samplesize ? pointWithMetric.samplesize : 0
              );

              if (val == "I/S") {
                pointWithMetric.tooltip = val;
              } else {

                let sigClass =
                  changeVal < pointWithMetric.Sig_LowerLimt
                    ? 'red'
                    : changeVal > pointWithMetric.Sig_UpperLimt
                      ? 'green'
                      : 'black';
                let text =
                  pointWithMetric.y1 != null
                    ? pointWithMetric.y +
                    (properties.dataLabelFormat ? '%' : '') +
                    ' ' +
                    `<span style="font-size: 80%;  color: ${sigClass};">(` +
                    `${pointWithMetric.cov != null
                      ? parseFloat(Number(changeVal).toFixed(1)) + (pointWithMetric.isPercentage
                        ? '%' : '')
                      : 'NA'
                    })</span>`
                    : 'NA';
                pointWithMetric.tooltip = text;
              }
              // return (
              //   '<span style:"color:' + 'black' + ';">' + text + '</span>'
              // );
            }
          }
          else {
            let finalText =
              this.y +
              (this.series.userOptions.data1[this.point.x]['isPercentage'] &&
                '%');
            finalText = configService.CheckLSorIScondition(
              configService.userRole,
              finalText,
              this.series.userOptions.data1[this.point.x]['Sample size']
            );
            pointWithMetric.tooltip = finalText;
          }


          if (this.series.name === 'Marker1') return false;
          let isDefaultTooltip = properties.toolTipStyle;
          const text = properties.showDataLabel
            ? this.series.userOptions.tooltip[this.point.x]
            : this.y;
          const dotColor = this.series.color;
          const backgroundcolor = properties.darkTheme ? '#b3b3b3' : '#f5f5f5';
          const backgroundcolor2 = properties.darkTheme ? '#dddddd' : 'white';
          if (isDefaultTooltip == 'style1') {
            const commonContent =
              `<div style="width:120%;border-left: 5px solid ${dotColor}; border-bottom: 5px solid ${dotColor}; z-index: 100; padding: 3%; border-radius: 5px; margin: 0; background-color: ${backgroundcolor2};">` +
              `<span style="display: block; text-align: center; color: ${dotColor}; font-weight: bold; font-size: 1rem;">Tooltip Title</span>` +
              `<span><strong>Series Name:</strong></span> ${this.series.userOptions.name}<br>` +
              `<span><strong>Category Name:</strong></span> ${this.series.userOptions.data1[this.point.x]['Category Name']
              }<br>` +
              `<span><strong>Value:</strong></span> ${pointWithMetric.tooltip}`;
            return commonContent + '</div>';
          } else {
            // Get the series color
            const content =
              `<div style="background-color: ${backgroundcolor}; padding: 10%; align-items: center; border: 1px solid ${dotColor}; width:120%">` +
              `<div style="display:flex"><div style="width: 1em; height: 1em; background-color: ${dotColor}; border-radius: 50%;"> </div>` +
              `<div style="width:90%; padding-left:5%;"> ${this.series.name} </div></div>` +
              `<div style="display: block; margin-top: 1%; margin-left:12%;"><strong>Value:</strong> ${pointWithMetric.tooltip}</div>`;
            return content + '</div>';
          }
        },
      } as any,
      // legend: this.LineTrendService.customizeLegend(properties.showLegend, properties.legendPosition, this.ChartProperties.darkTheme, this.ChartProperties.stacking),
      legend: {
        enabled: true,
        events: {
          itemHover: function (event: any) {
            // Display tooltip when hovering over legend item
            const point = event.target;
            const tooltip = document.createElement('div');
            tooltip.className = 'custom-tooltip';
            tooltip.style.position = 'absolute';
            tooltip.style.backgroundColor = 'rgba(0, 0, 0, 0.7)';
            tooltip.style.color = 'white';
            tooltip.style.padding = '5px';
            tooltip.style.borderRadius = '3px';
            tooltip.style.pointerEvents = 'none';
            tooltip.innerText = point.name;
            document.body.appendChild(tooltip);

            // Position tooltip
            document.addEventListener('mousemove', function (e) {
              tooltip.style.left = e.pageX + 10 + 'px';
              tooltip.style.top = e.pageY + 10 + 'px';
            });
          },
          itemMouseOut: function (event: any) {
            // Remove tooltip when mouse leaves legend item
            const tooltip = document.querySelector('.custom-tooltip');
            if (tooltip) {
              tooltip.remove();
            }
          },
        },
        // reversed: (this.ChartProperties.stacking == 1 || this.ChartProperties.stacking == 2) ? true : false,
        align: 'right',
        verticalAlign: 'middle',
        layout: 'vertical',
        // itemStyle: {
        //   color: "Black",
        //   fontWeight: "normal",
        //   fontSize: "0.8em",
        //   fontFamily: "Kantar Regular"
        // },
        width: 300,
        itemStyle: {
          fontWeight: 'normal',
          fontSize: this.height != '100%' ? '0.8em' : '1em',
          cursor: 'pointer',
        },
        useHTML: true,
        // symbolWidth: -1,
        // symbolHeight: -1,
        labelFormatter: function (): any {
          let point = this as any;
          // let textcolor = chartproperties.darkTheme ? 'white' : 'black';
          if (point.color != '#eeebed' && point.color != '#7f7f7f') {
            return (
              '<div style="display:flex;align-items:center;font-size:0.8em;" title="' +
              point.name +
              '">' +
              '<div style="display:flex;width:10px;height:10px;background-color:' +
              point.legendkeycolor +
              ';border-radius:50%"></div>' +
              '<div style="z-index: 10000; height: 20px; padding-left: 10px; padding-top: 1%; color: black; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; flex: 1; font: KantarBrown-Regular; cursor: pointer;" title="' +
              point.name +
              '">' +
              '   ' +
              point.name +
              '   ' +
              '</div>' +
              '</div>'
            );
          }
        },
      },
      plotOptions: {
        series: {
          animation: false,
        },
        line: {
          stacking:
            this.ChartProperties.stacking == 0
              ? ''
              : this.ChartProperties.stacking == 1
                ? 'normal'
                : 'percent',
          lineWidth: properties.lineWidth,
          dashStyle: properties.gridLineDashStyle,
          fillOpacity: 0.4,
          marker: {
            enabled: true,
            symbol: properties.markerStyle,
            radius: 4,
            lineWidth: properties.markerLineWidth,
          },
          dataLabels: {
            enabled: this.DataLabelOn,
            allowOverlap: true,
            align:
              properties.dataLabelPosition == 'left'
                ? 'right'
                : properties.dataLabelPosition == 'right'
                  ? 'left'
                  : 'center',
            rotation: properties.datalabelOrientation,
            backgroundColor: 'transparent',
            color: properties.darkTheme
              ? properties.dataLabelColor === 'default'
                ? 'white'
                : properties.dataLabelColor
              : properties.dataLabelColor === 'default'
                ? 'black'
                : properties.dataLabelColor,
            style: {
              fontSize: properties.dataLabelSize,
              textOutline: 'none',
              fontWeight: 'normal',
            },
            formatter: function (this: any) {
              const pointWithMetric = (
                this as Highcharts.TooltipFormatterContextObject
              ).point as {
                name?: any;
                parent?: any;
                color?: any;
                y?: number;
                y1?: number;
                cov?: string;
                significance?: string;
                samplesize?: number;
                significance2?: any;
                tooltip?: any;
                isPercentage?: any;
                Sig_LowerLimt?: any;
                Sig_UpperLimt?: any;
                Significance_Value?: any;
                indexValue?:any
              };
              const upwardTriangle = '&#9650';
              const downwardTriangle = '\u25BC';
              let roundedValue =
                this.series.userOptions.data1[this.point.x]['Rounded Value'];
              properties.dataLabelFormat = pointWithMetric.isPercentage;
              if (roundedValue == null) return 'NA';
              // if (properties.datalabelStyle === 'index') {
              //   let text2 =
              //     pointWithMetric.y1 != null ? pointWithMetric.y : 'NA';
              //   //text = configService.CheckLSorIScondition(configService.userRole, text, Number(pointWithMetric.samplesize));
              //   let color = configService.CheckIndexColoring(String(text2));
              //   text2 = `<span style="color: ${color} ;">${text2}</span>`;
              //   pointWithMetric.tooltip = text2;
              //   return (
              //     '<span style="color:' + 'black' + ';">' + text2 + '</span>'
              //   );
              // }
              if (properties.datalabelStyle === 'index') {

                let finalText =
                  this.y +
                  (this.series.userOptions.data1[this.point.x]['isPercentage'] &&
                    '%');
                finalText = configService.CheckLSorIScondition(
                  configService.userRole,
                  finalText,
                  this.series.userOptions.data1[this.point.x]['Sample size']
                );
                // pointWithMetric.tooltip = finalText;
    
    
                let text2 =
                pointWithMetric.y1 == 0 ? 'NA' :pointWithMetric.y1 != null ? pointWithMetric.indexValue : 'NA';
                //text = configService.CheckLSorIScondition(configService.userRole, text, Number(pointWithMetric.samplesize));
                let color = configService.CheckIndexColoring(String(text2));
                text2 = `<span style="color: ${color} ;">${text2}</span>`;
                pointWithMetric.tooltip =finalText+ "("+text2+")";
                return (
                  '<span style="color:' + 'black' + ';">' + finalText+ "("+text2+")" + '</span>'
                );
              }

              if (properties.datalabelStyle === 'sigChange') {
                let changeVal = pointWithMetric.isPercentage
                  ? Number(pointWithMetric.cov) * 100
                  : Number(pointWithMetric.cov);
                if (
                  pointWithMetric.cov == null ||
                  pointWithMetric.cov == 'NA'
                ) {
                  let text =
                    pointWithMetric.y1 != null
                      ? pointWithMetric.y +
                      (properties.dataLabelFormat ? '%' : '') +
                      ' ' +
                      `<span span style="font-size: 80%;color:black;">(${'NA'})</span>`
                      : 'NA';
                  pointWithMetric.tooltip = text;
                  return (
                    '<span style:"color:' + 'black' + ';">' + text + '</span>'
                  );
                } else {

                  let val = pointWithMetric.y != null
                    ? pointWithMetric.y +
                    (properties.dataLabelFormat ? '%' : '') : 'NA';
                  val = configService.CheckLSorIScondition(
                    configService.userRole,
                    val,
                    pointWithMetric.samplesize ? pointWithMetric.samplesize : 0
                  );

                  if (val == "I/S") {
                    return (
                      '<span style:"color:' + 'black' + ';">' + val + '</span>'
                    );
                  }

                  let sigClass =
                    changeVal < pointWithMetric.Sig_LowerLimt
                      ? 'red'
                      : changeVal > pointWithMetric.Sig_UpperLimt
                        ? 'green'
                        : 'black';


                  let text =
                    pointWithMetric.y1 != null
                      ? pointWithMetric.y +
                      (properties.dataLabelFormat ? '%' : '') +
                      ' ' +
                      `<span style="font-size: 80%;  color: ${sigClass};">(` +
                      `${pointWithMetric.cov != null
                        ? parseFloat(Number(changeVal).toFixed(1)) + (pointWithMetric.isPercentage
                          ? '%' : '')
                        : 'NA'
                      })</span>`
                      : 'NA';
                  pointWithMetric.tooltip = text;
                  return (
                    '<span style:"color:' + 'black' + ';">' + text + '</span>'
                  );
                }
              }
              // if (properties.datalabelStyle == "index") {
              //   let text = this.series.userOptions.roundedValue[this.point.x - 1] != null ? this.y + (this.series.data[0].ispercent ? '%' : '') : "NA";

              //   text = configService.CheckLSorIScondition(configService.userRole, text, this.series.userOptions.sampleSize[this.point.x - 1],);

              //   this.series.userOptions.tooltip[this.point.x - 1] = text;

              //   // let text2 = this.series.userOptions.roundedValue[this.point.x - 1] === 0
              //   //   ? serviceBar.nullValueText
              //   //   : this.series.userOptions.roundedValue[this.point.x - 1] == -1 ? -1 : this.series.userOptions.roundedValue[this.point.x - 1] != null ? this.point.indexValue : serviceBar.nullValueText;

              //   let text2 = this.point.actualIndexValue == null
              //   ? "NA"
              //     : this.series.userOptions.roundedValue[this.point.x - 1] == -1 ? -1 : this.series.userOptions.roundedValue[this.point.x - 1] != null ? this.point.indexValue : "NA";

              //   if (text2 == "-1" || text2 == -1) {
              //     text2 = "NA";
              //   }
              //   text2 = configService.CheckLSorIScondition(configService.userRole, text2, this.series.userOptions.sampleSize[this.point.x - 1],);


              //   let color = configService.CheckIndexColoring(text2);

              //   this.series.userOptions.tooltip[this.point.x - 1] = text + "(" + text2 + ")";;
              //   return (
              //     '<span style="font-size:0.5rem;">' + text + '</span>' +
              //     '<span style="color:' + color + ';font-size:0.45rem;">' + " " + '(' + text2 + ')</span>'
              //   );
              // }
              let finalText =
                this.y +
                (this.series.userOptions.data1[this.point.x]['isPercentage'] &&
                  '%');
              finalText = configService.CheckLSorIScondition(
                configService.userRole,
                finalText,
                this.series.userOptions.data1[this.point.x]['Sample size']
              );
              pointWithMetric.tooltip = finalText;
              this.series.userOptions.tooltip[this.point.x] = finalText;
              return finalText;
              // if (properties.datalabelStyle == "significance + changeVs") {
              //   text = this.y + (this.series.userOptions.data1[this.point.x]["isPercentage"] && '%');
              //   changeText = this.series.userOptions.data1[this.point.x]["ChangeVs"];
              //   let sig = this.series.userOptions.data1[this.point.x]["Significance"];
              //   let s = sig > 0 ? upwardTriangle : (sig < 0 ? downwardTriangle : '');
              //   let sigcolor = sig > 0 ? 'green' : (sig < 0 ? 'red' : '');
              //   let finalText = '<span>' + text +
              //     (changeText ? '&nbsp;<span>' +
              //       '' + `<span style="font-size: 80%; color:${properties.darkTheme ? "white" : "black"}">(` + changeText + ')</span>' + '&nbsp;' +
              //       '<span style="color:' + sigcolor + ';">' + s + '</span>' : '') +
              //     '</span>';
              //   this.series.userOptions.tooltip[this.point.x] = finalText;

              //   return (
              //     finalText
              //   );
              // }

              // if (properties.datalabelStyle == "change") {
              //   text = this.y + (this.series.userOptions.data1[this.point.x]["isPercentage"] && '%')
              //   //text = this.y != 0 ? this.y + ( ispercentage && '%' ) : 'NA';
              //   changeText = this.series.userOptions.data1[this.point.x]["ChangeVs"];
              //   let finalText = '<span>' + text + '' +
              //     (changeText ? `<span style="font-size: 80%; color:${properties.darkTheme ? "white" : "black"}">(` + changeText + ')</span>' : '') +
              //     '</span>'
              //   this.series.userOptions.tooltip[this.point.x] = finalText;
              //   return (
              //     finalText
              //   );
              // }

              // if (properties.datalabelStyle == "significance") {
              //   text = this.y + (this.series.userOptions.data1[this.point.x]["isPercentage"] && '%');
              //   // text = this.y != 0 ? this.y + ( ispercentage && '%' ) : 'NA';
              //   let sig = this.series.userOptions.data1[this.point.x]["Significance"];
              //   let s = sig > 0 ? upwardTriangle : (sig < 0 ? downwardTriangle : '');
              //   let sigcolor = sig > 0 ? 'green' : (sig < 0 ? 'red' : '');
              //   let finalText = '<span >' + text + '&nbsp<span style="color:' + sigcolor + ';">' + s + '</span></span>';
              //   this.series.userOptions.tooltip[this.point.x] = finalText;
              //   return (
              //     finalText
              //   );
              // }

              // if (properties.datalabelStyle == "significance2") {
              //   text = this.y + (this.series.userOptions.data1[this.point.x]["isPercentage"] && '%');
              //   changeText = this.series.userOptions.data1[this.point.x]["ChangeVs"];
              //   let sig = this.series.userOptions.data1[this.point.x]["Significance"];
              //   let sig1 = this.series.userOptions.data1[this.point.x]["Significance2"];
              //   let s = sig > 0 ? upwardTriangle : (sig < 0 ? downwardTriangle : '');
              //   let changeColor = sig1 < 0 ? 'red' : (sig1 > 0 ? 'green' : properties.darkTheme ? "white" : "Black");
              //   let sigcolor = sig > 0 ? 'green' : (sig < 0 ? 'red' : '');
              //   let finalText = '<span>' + text +
              //     (changeText ? '&nbsp<span style="color:' + ';"> ' +
              //       '<span style="font-size: 80%; color:' + changeColor + ';">(' + changeText + ')</span>&nbsp' +
              //       '<span style="color:' + sigcolor + ';">' + s + '</span>' : '') +
              //     '</span>';
              //   this.series.userOptions.tooltip[this.point.x] = finalText;
              //   return (
              //     finalText
              //   );
              // }

              // if (properties.datalabelStyle == "ls") {
              //   text = this.series.userOptions.data1[this.point.x]["Sample size"] >= samplesizeConstantValue ? this.y + (this.series.userOptions.data1[this.point.x]["isPercentage"] && '%') : 'LS';
              //   let finalText = '<b>' +
              //     text +
              //     '</b> ' +
              //     '<span style="opacity: 0.5"></span>';
              //   this.series.userOptions.tooltip[this.point.x] = finalText;
              //   return (
              //     finalText
              //   );
              // }
            },
          },
        },
      },
      series: this.seriesData,
    } as any);

    var chart = this.chart;
    var legendWidth = chart.legend.legendWidth;
    // Adjust margins based on the legend width

    if (
      this.ChartProperties.legendPosition == 'left' &&
      this.ChartProperties.showLegend
    ) {
      this.chart.update(
        {
          chart: {
            marginLeft: legendWidth + 40, // Add some extra space
            marginRight: 30,
          },
        },
        false
      );
    }

    if (
      this.ChartProperties.legendPosition == 'right' &&
      this.ChartProperties.showLegend
    ) {
      this.chart.update(
        {
          chart: {
            marginLeft: 60, // Add some extra space
            marginRight: legendWidth + 25,
          },
        },
        false
      );
    }
  }

  // getTooltipValue(value:any,actualValue:any,sampleSize:any){
  //   if(sampleSize >= 1000){
  //     return actualValue == null ? 'NA' : value;
  //   }
  //   return actualValue == null ? 'NA' : "LS";
  // }

  extractDisplayName(metricName: string): string {
    if (!metricName) return metricName;
    const parts = metricName.split('|');

    if (parts.length <= 1) {
      return metricName;
    }

    const firstPart = parts[0].trim();
    const metricGroupsToRemove = ['Familiarity', 'Imagery'];

    if (metricGroupsToRemove.some(group => firstPart === group)) {
      return parts[parts.length - 1].trim();
    } else {
       return metricName;
    }
  }

  prepareSeriesDataForChart() {
    this.seriesData = [];

    this.LineChartData = this.chartMainData;

    let metrics = _.uniqBy(this.LineChartData, 'Series Name').map((item) => {
      return item['Series Name'];
    });

    this.categoriesList = _.uniqBy(this.LineChartData, 'Category Name').map(
      (item) => {
        return item['Category Name'];
      }
    );

    let uniqueDataValue = _.uniqBy(this.LineChartData, 'Rounded Value').map(
      (item) => {
        return item['Rounded Value'];
      }
    );

    if (this.ChartProperties.datalabelStyle === 'lowSample') {
      this.showLowSample = true;
    } else {
      this.showLowSample = false;
    }

    let minValue = Math.min(...uniqueDataValue);
    let maxValue = Math.max(...uniqueDataValue);
    this.chartMinAxis = minValue;
    this.chartMaxAxis = maxValue + maxValue * 0.05;

    let idx = 0;
    let dataObject: any = {};
    let consumableData: any = [];
    let consumableData1: any = [];

    metrics.forEach((metric) => {
      dataObject = {};
      consumableData = [];
      consumableData1 = [];

      //let metricData = this.LineChartData.filter( res => res["Series Name"] == metric);
      let i = 0;
      this.categoriesList.forEach((item: any) => {
        let metricData: any;
        metricData = this.LineChartData.filter(
          (res) => res['Series Name'] == metric && res['Category Name'] == item
        )[0];
        if (!this.updateCategoryName.includes(metricData['Category Image'])) {
          this.updateCategoryName.push(metricData['Category Image']);
        }

        if (this.showLowSample) {
          if (metricData['Sample size'] < this._configService.ISthreshold) {
            consumableData.push({
              y: 0,

            });
          } else {
            consumableData.push({
              y:
                metricData['Value'] == null
                  ? null
                  : Number(
                    parseFloat(metricData['Value']).toFixed(
                      this.ChartProperties.decimalRoundOff
                    )
                  ),
               indexValue:metricData['ValueForIndex'] == null
              ? null
              : Number(
                parseFloat(metricData['ValueForIndex']).toFixed(
                  this.ChartProperties.decimalRoundOff
                )
              )
            });
          }
        } else {
          if (
            this._configService.userRole != 'superadmin' &&
            metricData['Sample size'] < this._configService.ISthreshold
          ) {
            consumableData.push({
              y: 0,
              cov: "I/S",
            });
          } else {
            consumableData.push({
              name: metric,
              y:
                metricData['Value'] == null
                  ? null
                  : Number(
                    parseFloat(metricData['Value']).toFixed(
                      this.ChartProperties.decimalRoundOff
                    )
                  ),
              y1:
                metricData['Value'] == null
                  ? null
                  : Number(
                    parseFloat(metricData['Value']).toFixed(
                      this.ChartProperties.decimalRoundOff
                    )
                  ),
                  indexValue:metricData['ValueForIndex'] == null
                  ? null
                  : Number(
                    parseFloat(metricData['ValueForIndex']).toFixed(
                      this.ChartProperties.decimalRoundOff
                    )
                  ),
              cov: metricData['ChangeVs'],
              significance: metricData['Significance'],
              samplesize: metricData['Sample size'],
              significance2: metricData['Significance2'],
              tooltip: '',
              isPercentage: metricData['isPercentage'],
              Sig_LowerLimt: metricData['Sig_LowerLimt'],
              Sig_UpperLimt: metricData['Sig_UpperLimt'],

              // "Series Name": lev2.metricName,
              // "Category Name": dataArr.lvl1Child,
              // "Rounded Value": dataArr.data == null ? null : dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : dataArr.data,
              // "Value": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : dataArr.data,
              // "Label": dataArr.data == null ? "NA" : dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : dataArr.data,
              // "ChangeVs": dataArr.changeVsPY,
              // "Significance": "-1",
              // "Sample size": dataArr.baseValueforLSorIs,
              // "Significance2": "1",
              // "Category Image": "Category_Image_1",
              // "isPercentage": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? true : false,
              // "Sig_LowerLimt": this.Sig_LowerLimt,
              // "Sig_UpperLimt": this.Sig_UpperLimt
            });
          }
        }
        consumableData1.push(metricData);
        i++;
      });

      // Use the helper function to extract the display name without metric group prefix
      dataObject.name = this.extractDisplayName(metric);
      dataObject.color = this.colorCodeList[idx++];
      dataObject.data = consumableData;
      dataObject.data1 = consumableData1;
      dataObject.connectNulls = false;
      dataObject.tooltip = [];
      //dataObject.pointPlacement = "on";
      this.seriesData.push(dataObject);
    });
  }

  getDataValue(sampleSize: any, value: any) {
    if (sampleSize >= this.samplesizeConstantValue) return value;
    return 0;
  }

  userselectedproperties() {
    let linechartData = {
      data: this.LineChartData,
      Properties: [this.ChartProperties],
      title: this.data.title,
    };
    return JSON.stringify(linechartData).toString();
  }

  ngOnDestroy(): void {
    // Unsubscribe to prevent memory leaks and unnecessary reloads
    this.subscriptions.unsubscribe();
  }
}
